import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #PRIMARY NAV
\*------------------------------------ */
/**
 * 1) Primary navigation of the site. This should only used within the header component
 */
/**
 * Actual web component wrapper
 * 1) Used to help with the priority plus more behavior for the width
 */
:host {
  flex: 1; /* 1 */
  max-width: 100%;
  overflow: hidden;
}

:host([isMobile]) {
  flex: none;
  overflow: visible;
}

:host([panelOpen]) {
  overflow: visible;
}

/**
 * Primary navigation
 */
.cat-c-primary-nav {
  --cat-list-item-background-color: transparent;
  display: flex;
  width: auto;
}
.cat-c-primary-nav.cat-is-mobile {
  display: none;
}
.cat-c-primary-nav.cat-is-mobile.cat-is-collapsed {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: var(--cat-primary-nav-positon-top-mobile, var(--cat-space-5x-large));
  background: var(--cat-theme-color-background-xstrong);
  z-index: var(--cat-z-index-300);
  height: var(--cat-primary-nav-height-mobile, calc(100vh - var(--size-base-unit) * 7));
  overflow: auto;
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: var(--cat-space-x-large);
  --cat-list-item-link-hover-background: var(--cat-theme-color-background-xstrong-hover);
  --cat-list-item-link-font-color: var(--cat-theme-color-content-knockout);
  --cat-heading-color-content: var(--cat-theme-color-content-knockout);
}

/**
 * Primary nav list
 * 1) Stack on small screens within the toggleable menu but place side by side on large screens
 */
.cat-c-primary-nav__list {
  display: flex;
  flex-direction: column; /* 1 */
  margin: 0;
  padding: 0;
  list-style: none;
}
.cat-c-primary-nav:not(.cat-is-mobile) .cat-c-primary-nav__list {
  flex-direction: row; /* 1 */
}
.cat-c-primary-nav__list ::slotted(cat-primary-nav-item) {
  width: 100%;
}
.cat-c-primary-nav--full-width .cat-c-primary-nav__list {
  width: var(--cat-primary-nav-item--full-width, 100%);
}

.cat-c-primary-nav__more {
  display: none;
  /**
   * Subnav more list within collapsed subnav nav
   * 1) Show "more" button with dropdown
   */
}
.cat-c-primary-nav__more.cat-is-collapsed {
  display: none;
}
.cat-c-primary-nav:not(.cat-is-mobile) .cat-c-primary-nav__more.cat-is-collapsed {
  display: block; /* 1 */
}

/**
  * Slotted hidden class
  * 1) Hide the item from the viewer
  */
.cat-c-primary-nav:not(.cat-is-mobile) ::slotted(.cat-is-hidden) {
  display: none;
}

/**
 * Subnav more list
 */
.cat-c-primary-nav__more-list {
  display: none;
  list-style: none;
  margin: 0 var(--cat-space-x-small) 0 0;
  padding: 0;
}
.cat-c-primary-nav:not(.cat-is-mobile) .cat-c-primary-nav__more-list {
  margin-inline-start: auto;
}

/**
 * Subnav more dropdown item
 * 1) Hide until visible class is added
 * 2) TODO Rename
 */
.cat-c-primary-nav__more-dropdown-item {
  display: none; /* 1 */
}

/**
 * Visible Subnav more dropdown item
 * 1) Show item when visible class is added
 * 2) TODO Rename
 */
.cat-c-primary-nav__more-dropdown-item.cat-is-visible {
  display: block;
}

.cat-c-primary-nav__more-dropdown {
  list-style: none;
  margin: 0;
  padding: 0;
}
.cat-c-primary-nav__more-dropdown cat-primary-nav-item {
  display: content;
}

.cat-c-primary-nav__dropdown-link {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: block;
  width: 100%;
  appearance: none;
  border: none;
  outline: none;
  padding: var(--cat-space-x-small);
  background: none;
  text-align: start;
  text-decoration: none;
  color: var(--cat-theme-color-content-default);
  border-radius: var(--cat-theme-border-radius);
  cursor: pointer;
  transition: background var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-primary-nav__dropdown-link:hover, .cat-c-primary-nav__dropdown-link:focus {
  background: var(--cat-theme-color-background-subtle);
}

.cat-c-primary-nav__sublist {
  white-space: nowrap;
}
`;
       